import { ListResponseModel, toQueryString } from ".";
import { SolarProviderOrderModel } from "../model/orders/orders";
import { ProviderBusinessInfo, SolarProviderInfoQuery } from "../model/provider/provider-dashboard-data";
import { SolarProduct } from "../model/solar-product/solar-product";
import { apiSlice } from "../stores/base/api-slice";
const adminEndpoints = apiSlice.injectEndpoints({
	endpoints: builder => ({
		getSolarProviderInformation: builder.query<ProviderBusinessInfo, SolarProviderInfoQuery>({
			query: ({ companyId, start, end }) => ({
				url: "/product/company/get-company-info" + toQueryString({ companyId, start, end }),
				method: "GET",
			}),
			providesTags: ["SolarProviderInformation"],
		}),
		getProviderProductsCount: builder.query<number, {companyId: string}>({
			query: ( companyId) => ({
				url: "/product/solar-product/count-of-products" + toQueryString({ companyId}),
				method: "GET",
			}),
			providesTags: ["SolarProviderInformation"],
		}),
		toggleSolarProviderSuspension: builder.mutation<any, string>({
			query: companyId => ({
				url: `/product/provider/toggle-suspend` +  toQueryString({ companyId }),
				method: "POST",
			}),
			invalidatesTags: ["SolarProviderInformation"],
		}),
		getSolarProviderProducts: builder.query<ListResponseModel<Array<SolarProduct>>, SolarProviderInfoQuery>({
			query: ({ page, pageSize, companyId }) => ({
				url: "product/solar-product/products-with-loan/page/admin" + toQueryString({ page, pageSize, companyId }),
				method: "GET",
			}),
			providesTags: ["SolarProducts"],
		}),
		getSolarProviderOrders: builder.query<ListResponseModel<Array<SolarProviderOrderModel>>, SolarProviderInfoQuery>({
			query: ({ page, pageSize, SolarProviderId, start, end }) => ({
				url: "/solar-provider/page/orders" + toQueryString({ page, pageSize, SolarProviderId, start, end }),
				method: "GET",
			}),
		}),
		pauseSolarProduct: builder.mutation<any, { id?: string; actionCode?: string | null }>({
			query: ({ id, actionCode }) => ({
				url: `/solar-product/admin/pause/${id}`,
				method: "POST",
				body: { actionCode },
			}),
			invalidatesTags: ["SolarProducts"],
		}),
		getOrderDetails: builder.query<any, string>({
			query: id => ({
				url: `/orders/${id}`,
				method: "POST",
			}),
		}),
	}),
});

export const {
	useLazyGetSolarProviderInformationQuery,
	useToggleSolarProviderSuspensionMutation,
	useLazyGetSolarProviderProductsQuery,
	useLazyGetSolarProviderOrdersQuery,
	usePauseSolarProductMutation,
	useGetProviderProductsCountQuery,
} = adminEndpoints;
